import axios, { AxiosRequestConfig } from 'axios'

// Get API URL from environment variable
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || 'http://localhost:4401'

// Debug log
console.log('[Request Service] API_BASE_URL:', API_BASE_URL)

export default class _Request {
    API_URL = API_BASE_URL;

    private getAuthHeaders(): Record<string, string> {
        const token = localStorage.getItem('token');
        if (token) {
            return {
                'Authorization': token // Token already includes "Bearer " prefix
            };
        }
        return {};
    }

    private getConfig(additionalConfig?: AxiosRequestConfig): AxiosRequestConfig {
        return {
            headers: {
                ...this.getAuthHeaders(),
                'Content-Type': 'application/json',
                ...additionalConfig?.headers
            },
            ...additionalConfig
        };
    }

    public async get(url: string, config?: AxiosRequestConfig): Promise<any> {
        return await axios.get(this.API_URL + url, this.getConfig(config));
    }

    public async post(url: string, data: any = null, config?: AxiosRequestConfig): Promise<any> {
        return await axios.post(this.API_URL + url, data, this.getConfig(config));
    }

    public async put(url: string, data: any = null, config?: AxiosRequestConfig): Promise<any> {
        return await axios.put(this.API_URL + url, data, this.getConfig(config));
    }

    public async delete(url: string, config?: AxiosRequestConfig): Promise<any> {
        return await axios.delete(this.API_URL + url, this.getConfig(config));
    }
}
